module.exports = __webpack_public_path__ + "img/p07701.ed6e4e83.png";